import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './BaseDialogButton.module.css';
export type BaseDialogButtonProps = ComponentProps<'button'>;
export const BaseDialogButton: FunctionComponent<BaseDialogButtonProps> = React.memo(props => {
  const $ = _c(10);
  let children;
  let t0;
  let t1;
  let t2;
  if ($[0] !== props) {
    const {
      children: t3,
      className,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t3;
    t0 = "button";
    t1 = remainingProps;
    t2 = classes(className, styles.button);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <button type={t0} {...t1} className={t2}>{children}</button>;
    $[5] = children;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});